import { Table } from "@tanstack/react-table";

// Utils for our filtering UI
// - Filter addition and removal / visibility
export function useTSTFilterUtils<T>(table: Table<T>) {
    const filterableColumns = table
        .getAllColumns()
        .filter((column) => column.getCanFilter());

    const selectedFilterColumnIds = table
        .getState()
        .columnFilters.map((filter) => filter.id);

    const selectedFilterColumns = filterableColumns
        .filter((filterHeader) =>
            selectedFilterColumnIds.some((colId) => colId === filterHeader.id)
        )
        .sort(
            (a, b) =>
                selectedFilterColumnIds.indexOf(a.id) -
                selectedFilterColumnIds.indexOf(b.id)
        );

    return {
        filterableColumns,
        selectedFilterColumnIds,
        selectedFilterColumns,
    };
}
